module.exports = __webpack_public_path__ + "static/media/Thirdpartypet.ee6ae078.png";